import { render, staticRenderFns } from "./xstudy.vue?vue&type=template&id=27f01f88&scoped=true&"
import script from "./xstudy.vue?vue&type=script&lang=js&"
export * from "./xstudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f01f88",
  null
  
)

export default component.exports